/**
 * @file 追加・非表示の操作が可能なマスタメンテナンス画面の更新ボタン
 */

'use strict'

import Common from "../../Utils/Common"


/**
 * @classname BtnUpdateInternalMemo
 * @classdesc 追加・非表示の操作が可能なマスタメンテナンス画面の更新ボタン
 */
export default class BtnUpdateInternalMemo {
	/**
	 * @constructor
	 * @param {jQuery} $e - $('.btn-update-internal-memo')
	 */
	constructor($e, controller) {
		console.log(`BtnUpdateInternalMemo.constructor`)
		this._$e = $e
		this._controller = controller
		this._$textarea = $('#japan_council_internal_memo');
		this._$e.on('click', () => this.onClick())
	}


	/**
	 * クリックのコールバック
	 *
	 * @memberof BtnUpdateInternalMemo
	 * @return {undefined}
	 */
	onClick() {
		console.log(`BtnUpdateInternalMemo.onClick`);
		const memo = this._$textarea.val();
		const formData = new FormData()
		formData.append('origin_apply_id', this._$e.data('apply-id'));
		formData.append('administration_remarks', memo);
		Common.logFormData(formData);
		this._controller.updateInternalMemo(formData);
	}


	/**
	 * FormDataを作成
	 *
	 * @memberof BtnUpdateInternalMemo
	 * @return {undefined}
	 */
	appendFormData() {
		console.log(`BtnUpdateInternalMemo.appendFormData`)
		return formData
	}
}
